import { ChevronLeftIcon, ChevronRightIcon } from "../Icons"
import { PaginationHook } from "./usePagination"
import { callCSSFn, CSSFn, styled, StyleProps } from "../styles"
import { Button } from "../Button"
import { Flex } from "../Flex"
import { Text } from "../Typography"
import * as styles from "./paginationStyles"
import { Box } from "../Box"
import { PaginationButton } from "./PaginationButton"

export type PaginationDataTestIds = {
  root?: string
  next?: string
  previous?: string
}

export type PaginationProps = React.ComponentPropsWithRef<"div"> &
  Readonly<{
    dataCount: number
    pagination: PaginationHook
    dataTestIds?: PaginationDataTestIds
    css?: CSSFn
  }>

export const Pagination: React.FC<PaginationProps> = ({
  dataCount,
  dataTestIds,
  pagination,
  ...containerProps
}: PaginationProps) => {
  const { pageIndex, pageSize, pageCount, prevDisabled, nextDisabled, onNextPage, onPrevPage, changePageSize } =
    pagination
  if (dataCount === 0 || pageCount === 1) return null

  return (
    <Container data-testid={dataTestIds?.root} {...containerProps}>
      <Box>
        <PaginationButton value={pageSize} options={[10, 50, 100]} total={dataCount} onChange={changePageSize} />
      </Box>
      <Flex alignItems="center">
        <Text css={styles.text}>{`${pageIndex + 1} of ${pageCount} pages`}</Text>
        <Button
          data-testid={dataTestIds?.previous || `PREVIOUS_PAGE`}
          variant="pagination"
          onClick={onPrevPage}
          disabled={prevDisabled}
          css={styles.makeIconButtonStyle}
        >
          <ChevronLeftIcon />
        </Button>
        <Button
          data-testid={dataTestIds?.next || `NEXT_PAGE`}
          variant="pagination"
          onClick={onNextPage}
          disabled={nextDisabled}
          css={styles.makeIconButtonStyle}
        >
          <ChevronRightIcon />
        </Button>
      </Flex>
    </Container>
  )
}

const Container = styled.div((props: StyleProps) => ({
  fontSize: props.theme.fontSize.caption,
  display: `flex`,
  width: `100%`,
  justifyContent: `space-between`,
  alignItems: `center`,
  padding: props.theme.spacing(5, 0, 0),
  margin: props.theme.spacing(0),
  borderTop: `.5px solid ${props.theme.palette.grey.dark}`,
  ...callCSSFn(props),
}))
